module.exports = __webpack_public_path__ + "img/AE.fa416e40.svg";